<script>
import { reg_json } from '$lib/static/reg_json.js';
import { map_flyToDataTarget } from '$lib/app/lib.js';
import { get_int_id_by_reg } from '$lib/app/static.js';

import Icon from '$lib/app/Icon.svelte';
import Flag from '$lib/app/Flag.svelte';

let {
    db = [],
    user_stats_reg = [],
    map = $bindable(null),
    switch_state = $bindable(2),
    default_macro_reg = $bindable(null),
    current_unp = $bindable(null),
    selectedRegIntId = $bindable(),
} = $props();

let current_macro_reg = $state(null);

function tlad_name_by_unp(unp) {
    switch(unp) {
        case 'AU':
        case 'AT':
        case 'BR': 
        case 'DE': 
        case 'FM': 
        case 'IN': 
        case 'US':
        case 'MX':
            return 'states';

        case 'CA':
        case 'IE':
        case 'NC':
        case 'KR':
        case 'KP':
        case 'ZA':
            return 'provinces';

        case 'RU':
        case 'UA':
            return 'oblasts';

        case 'CH':
            return 'cantons';

        case 'ES':
            return 'autonomous communities';

        case 'AG':
        case 'BQ':
        case 'KN':
        case 'PM':
        case 'ST':
        case 'TT':
        case 'WF':
            return 'islands';

        case 'CV':
        case 'FJ':
        case 'KI':
        case 'TO':
            return 'island groups';

        case 'PF':
            return 'archipelagos';

        case 'AE':
            return 'emirates';

        default:
            return 'regions';
    }

}

function selectMacroReg(e) {
    e.preventDefault();
    if(current_macro_reg == e.currentTarget?.id) {
        current_macro_reg = null;
    } else {
        current_macro_reg = e.currentTarget?.id;
    }
    current_unp = null;
}

const continents_i = {
    "EUW": "europe.png",
    "NAM": "north-america.png",
    "ASN": "asia.png",
    "AFN": "africa.png",
    "SAM": "south-america.png",
    "ANZ": "australia.png",
    "ANT": "antarctica.png"
}

/*
let visitedRegionsNo = $derived.by(() => {
    let visitedRegionsNo = {};
    for (const macro_reg of reg_json) {
        if(macro_reg?.db) {
            for (const country of macro_reg.db) {
                if(country?.db) {
                    const no = country.db.reduce(function(acc, cv) { return acc + (user_stats_reg[cv.id] ? 1 : 0) }, 0);
                    if(no) {
                        visitedRegionsNo[country.id] = no;
                    }
                } else {
                    if(user_stats_reg[country.id]) {
                        visitedRegionsNo[country.id] = 1;
                    }
                }
            }
        }
        visitedRegionsNo[macro_reg.id] = macro_reg.db.reduce(function(acc, cv) { return acc + (visitedRegionsNo?.[cv?.id] || 0) }, 0);
    }
    return visitedRegionsNo;
});
*/

let visitedRegionsNo = $derived.by(() => {
    let visitedRegionsNo = {};
    for (const macro_reg of reg_json) {
        visitedRegionsNo[macro_reg.id] = {};
        if(macro_reg?.db) {
            for (const country of macro_reg.db) {
                if(country?.db) {
                    const no = country.db.reduce(function(acc, cv) { return acc + (user_stats_reg[cv.id] ? 1 : 0) }, 0);
                    if(no) {
                        visitedRegionsNo[macro_reg.id][country.id] = no;
                    }
                } else {
                    if(user_stats_reg[country.id]) {
                        visitedRegionsNo[macro_reg.id][country.id] = 1;
                    }
                }
            }
        }
        visitedRegionsNo[macro_reg.id][macro_reg.id] = macro_reg.db.reduce(function(acc, cv) { return acc + (visitedRegionsNo[macro_reg.id]?.[cv?.id] || 0) }, 0);
    }
    return visitedRegionsNo;
});

$inspect('visitedRegionsNo='+JSON.stringify(visitedRegionsNo));

</script>

<!--{current_macro_reg} {current_unp}-->
<!--BeenTableSwitch bind:state={switch_state}/-->

<!--pre>
    {JSON.stringify(user_stats,undefined,2)}
</pre-->



<div class="columns">
    <div class="column is-one-third">
        <aside class="menu">
            <ul class="menu-list">
                {#each reg_json as macro_reg}
                    <li><a tabindex=0 id={macro_reg?.id} onclick={selectMacroReg}>
                            <b>{macro_reg?.name}</b>
                            ({visitedRegionsNo[macro_reg.id][macro_reg.id]}/{macro_reg?.total})&nbsp;<Icon id={macro_reg?.id !== current_macro_reg ? "" : "angle-up"}/>

                            </a>
                        {#if macro_reg?.id == current_macro_reg}
                            <ul>
                                {#each macro_reg?.db as country}
                                    <!--{#if (switch_state<3&&user_stats.unp[country.id]) || (switch_state>1&&!user_stats.unp[country.id])}-->
                                    {#if (switch_state<3 && visitedRegionsNo[macro_reg.id]?.[country.id] > 0) || (switch_state>1 && !visitedRegionsNo[macro_reg.id]?.[country.id])}
                                        <li>
                                            <a 
                                                class:is-active={current_unp == country} 
                                                onclick={(e) => { e.preventDefault(); current_unp = country }}
                                            >
                                                    <Flag reg={country.id}/>&nbsp;<span class:bold={visitedRegionsNo[macro_reg.id]?.[country.id]}>{country.name}</span>&nbsp;
                                                    {#if visitedRegionsNo[macro_reg.id]?.[country.id] > 0}
                                                        ({visitedRegionsNo[macro_reg.id][country.id]}/{country?.total || 1})
                                                    {/if}
                                            </a>
                                        </li>
                                    {/if}
                                {/each}
                            </ul> 
                        {/if}
                    </li>
                {/each}
            </ul>
          </aside>    
        </div>
    <div class="column">
        {#if current_macro_reg && current_unp} <!--?.id--><!-- && (current_unp?.db || current_unp.visited > 0)}-->
            <div class="content sticky">
            <h3 class="h3">{current_unp.name}</h3>
            {#if visitedRegionsNo[current_macro_reg]?.[current_unp.id] > 0}
                {#if current_unp?.total > 1}
                    <h5 class="h5">{visitedRegionsNo[current_macro_reg][current_unp.id]} of {current_unp?.total} {tlad_name_by_unp(current_unp?.id)} visted ({Math.round(visitedRegionsNo[current_macro_reg][current_unp.id]/current_unp?.total*100)}%)</h5>
                {:else}
                    <Icon id=check/>
                {/if}
            {:else}
                <h5 class="h-not-visited">Not visited</h5>
            {/if}
            <!--
            {#if current_unp?.visited > 0}
                {#if current_unp?.total > 1}
                    <h5 class="h5">{current_unp?.visited || 0} of {current_unp?.total} {tlad_name_by_unp(current_unp?.id)} visted ({Math.round(current_unp?.visited/current_unp?.total*100)}%)</h5>
                {:else}
                    <Icon id=check/>
                {/if}
            {:else}
                <h5 class="h-not-visited">Not visited</h5>
            {/if}-->
            <table class="table is-striped is-fullwidth" onmouseleave={()=>{selectedRegIntId=undefined}}>
                <thead>
                    <tr>
                        {#if import.meta.env.DEV}<th class="reg-id-width"></th>{/if}
                        <th></th>
                        <th class="has-text-right w8pt">📍</th>
                    </tr>
                </thead>
                <tbody>
                    {#if current_unp?.db}
                        {#each current_unp?.db as rrow3}
                        <tr>
                                {#if import.meta.env.DEV}<td class="reg-id-width">{rrow3.id}</td>{/if}
                                <td class:bold={user_stats_reg?.[rrow3.id]>0}><Flag reg={rrow3.id}/>
                                    <span class="flyable-text"
                                        class:my-hover={selectedRegIntId == get_int_id_by_reg(rrow3.id)}
                                        onclick={(e) => map_flyToDataTarget(map,e)}
                                        onmouseover={() => { selectedRegIntId=get_int_id_by_reg(rrow3.id) }}
                                        data-target={rrow3.id}>{rrow3.name}</span>
                                </td>
                                <td class="has-text-right w8pt"><b>{user_stats_reg?.[rrow3.id] || ''}&nbsp;</b></td>
                        </tr>
                        {/each}
                    {:else}
                        <tr>
                            {#if import.meta.env.DEV}<td class="reg-id-width">{current_unp.id}</td>{/if}
                            <td class:bold={user_stats_reg?.[current_unp.id]>0}><Flag reg={current_unp.id}/>
                                <span class="flyable-text"
                                    class:my-hover={selectedRegIntId == get_int_id_by_reg(current_unp.id)}
                                    onclick={(e) => map_flyToDataTarget(map,e)}
                                    onmouseover={ () => { selectedRegIntId=get_int_id_by_reg(current_unp.id)} }
                                    data-target={current_unp.id}>{current_unp.name}</span>
                            </td>
                            <td class="has-text-right w8pt"><b>{user_stats_reg?.[current_unp.id] || ''}&nbsp;</b></td> 
                        </tr>
                    {/if}
                </tbody>
            </table>
            </div>
        {/if}
    </div>
</div>

<style>
    .h-not-visited {
        font-weight: normal;
    }

    .bold {
        font-weight: bold;
    }

    .reg-id-width {
        width: 16%;
    }

    .w8pt {
        width: 8%;
    }

    .sticky {
        position: sticky;
        top: 1rem;
    }

    .flyable-text {
        cursor: zoom-in;
        /*
        text-decoration: underline;
        text-decoration-style: dashed;
        text-decoration-skip: spaces edges;
        text-decoration-color: #c7c7c7;
        */
    }

    .my-hover {
        text-decoration: underline;
        text-decoration-style: double;
    }
</style>